import VideoPlayer from 'modules/video-player/video-player';
import 'modules/case-study-details/case-study-details';
import 'modules/blockquote/blockquote';
import 'modules/stats/stats';
import 'modules/image-set/image-set';
import 'modules/mega-link/mega-link';
import 'modules/swipe-carousel/swipe-carousel';
import './index.scss';

VideoPlayer.initializeAll();
